<ng-template #progressSpinnerRef>
    <progress-spinner></progress-spinner>
</ng-template>
